/**
 * Second half of the Okta login: the API dropped the token in a `token` cookie;
 * store it, load the profile and the config. Returns the path to go to next.
 */
import { api } from '@/shared/api/client';
import { fetchAppConfig } from '@/shared/config/app-config';
import { readCookie } from './cookies';
import { setLoginErrorCode, storeUserData, type UserProfile } from './session';

const errorCodeOf = (error: unknown): string =>
  error &&
  typeof error === 'object' &&
  typeof (error as { code?: unknown }).code === 'string'
    ? (error as { code: string }).code
    : 'errorGeneric';

export const completeLogin = async (): Promise<string> => {
  const token = readCookie('token');
  if (!token) {
    setLoginErrorCode('errorTokenMissing');
    return '/login';
  }
  try {
    storeUserData(token, {});
    // some fields might not be in the JWT token
    const user = await api.get<UserProfile>('user/me');
    storeUserData(token, user);
    await fetchAppConfig();
    return '/main';
  } catch (error) {
    console.error(error);
    setLoginErrorCode(errorCodeOf(error));
    return '/login';
  }
};
